function escapeHtml(text) {
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

/**
 * CRM stores mentions as [@Name](member:id) (see GeneralHelper::parseMentions).
 * Safe HTML for partner portal: escape, render mentions as @Name, preserve line breaks.
 */
export function formatStudentNoteHtml(text) {
  if (text == null || text === "") return "";
  let out = escapeHtml(text);
  // Same pattern as crm/app/Helpers/GeneralHelper.php parseMentions
  out = out.replace(/\[(.)(.+?)\]\((\w+):(.+?)\)/g, (_, _first, rest) => {
    return `<span class="student-note-mention">@${rest}</span>`;
  });
  return out.replace(/\r\n|\n|\r/g, "<br />");
}
